export async function readJSON(parameter,onLoad) {
    fetch(parameter)
    .then(response => {
        if (!response.ok) {
            console.log("data path doesn't exist");
            //checkExistingStorage();
            throw new Error('Network response was not ok');
        }
        return response.blob();
    })
    .then(blob => {
        var fileReader = new FileReader();
        fileReader.onloadend = function(e) {
            if (e.target !== null) {
                onLoad(e.target.result);
            }
        };
        fileReader.readAsText(blob);
    })
    .catch(error => {
        console.error('There has been a problem with your fetch operation:', error);
    });
}